import type { FC } from 'react';

import styles from './EmailSignatureSquircle.module.scss';

const EmailSignatureSquircle: FC<React.PropsWithChildren<unknown>> = () => {
  return <div className={styles['email-signature-squircle']}></div>;
};

export default EmailSignatureSquircle;
